import React from "react";
import {useSelector} from "react-redux";
import "./index.scss";

function View({title, missions, onClickCloseMenuBtn, onClickMissionList, onClickExitTutorialBtn}) {
  const isTutorialListOpened = useSelector(state => state.tutorial.isListOpened);
  const currentMissionIdx = useSelector(state => state.tutorial.missionIdx);
  const completedMissionIdx = useSelector(state => state.tutorial.completedMissionIdx);

  return (
    <div className={`tutorial-list tutorial-list--${isTutorialListOpened}`}>
      <div className="tutorial-list__header">
        <button className="tutorial-list__header__slide-home-btn" onClick={onClickExitTutorialBtn} />
        <button className="tutorial-list__header__slide-close-btn" onClick={onClickCloseMenuBtn} />
      </div>
      <div className="tutorial-list__missions">
        <p className="tutorial-list__missions__title">{title}</p>
        <ol className="tutorial-list__missions__list">
          {missions.map((mission, index) => {
            const classes = [];
            if (index === currentMissionIdx) {
              classes.push("selected");
            }

            if (index <= completedMissionIdx) {
              classes.push("completed");
            }

            const isDisabled = index > completedMissionIdx + 1;
            if (isDisabled) {
              classes.push("disabled");
            }
            return (
              <li key={index} className={classes.join(" ")} onClick={() => onClickMissionList(index)}>
                {mission.title}
              </li>
            );
          })}
        </ol>
      </div>
    </div>
  );
}

export default View;
